<template>
  <div>
    <!-- Tabs + Add button -->
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="plan-tabs">
        <button class="plan-tab saidas" :class="{ active: activeTab === 'saidas' }" @click="setTab('saidas')">Saídas</button>
        <button class="plan-tab entradas" :class="{ active: activeTab === 'entradas' }" @click="setTab('entradas')">Entradas</button>
      </div>
      <b-button @click="showAddModal(null)" variant="success" size="sm">+ Adicionar</b-button>
    </div>

    <!-- Table -->
    <div class="plan-table">
      <div class="plan-table-header">
        <span>Categoria</span>
        <span>Ações</span>
      </div>
      <TreeNode
        v-for="(node, index) in filteredNodes"
        :key="node.id || index"
        :node="node"
        :dreGrupos="dreGrupos"
        @add-child="addChild"
        @delete-node="deleteNode"
      />
      <div v-if="filteredNodes.length === 0" class="plan-empty">
        Nenhum plano de contas cadastrado nesta categoria.
      </div>
    </div>

    <b-modal v-model="modalVisible" title="Adicionar Plano de Contas" centered size="lg">
      <b-row>
        <b-col md="10">
          <b-form-group label="Descrição">
            <b-form-input v-model="newNodeName" maxlength="50" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="10" v-if="parentNode !== null">
          <b-form-group label="Grupo DRE:" label-for="dre-grupo-select">
            <b-form-select id="dre-grupo-select" v-model="newDreGrupo" :options="dreGruposOptions" />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <div>
          <b-button variant="primary" @click="saveNewNode" ref="saveNewNode" class="mr-2">Salvar</b-button>
          <b-button @click="cancel()">Cancelar</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import TreeNode from "./TreeNode.vue";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "Tree",
  mixins: [SistemaMixin],
  components: { TreeNode },
  props: {
    treeData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "saidas",
      modalVisible: false,
      newNodeName: "",
      parentNode: null,
      newParentType: 1,
      typeOptions: [
        { text: "Saída (Despesa)", value: 1 },
        { text: "Entrada (Receita)", value: 2 },
      ],
      newDreGrupo: null,
      dreGrupos: [],
    };
  },
  computed: {
    dreGruposOptions() {
      return [
        { value: null, text: "Não classificado" },
        ...this.dreGrupos.map((g) => ({ value: g.id, text: g.label })),
      ];
    },
    filteredNodes() {
      if (this.activeTab === "entradas") return this.treeData.filter((n) => n.tipo === 2);
      return this.treeData.filter((n) => n.tipo !== 2);
    },
  },
  async mounted() {
    try {
      const { data } = await this.$http.get("/financeiro/dre-grupos");
      if (data && data.data) this.dreGrupos = data.data;
    } catch (e) {
      // silent
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
      this.newParentType = tab === "entradas" ? 2 : 1;
    },
    showAddModal(parent) {
      this.parentNode = parent;
      this.newNodeName = "";
      this.newDreGrupo = null;
      this.modalVisible = true;
    },
    async saveNewNode() {
      if (!this.newNodeName) return;
      this.addLoadingToButton("saveNewNode");
      const newNode = {
        descricao: this.newNodeName,
        children: [],
        tipo: this.newParentType,
        dre_grupo: this.newDreGrupo,
      };
      try {
        if (this.parentNode) {
          newNode.id_pai = this.parentNode.id;
          const { data } = await this.$http.post("/financeiro/create-plano-filho", newNode);
          if (data.data.id) {
            newNode.id = data.data.id;
            this.$toast.success("Plano adicionado com sucesso!");
          }
          this.parentNode.children.push(newNode);
        } else {
          const { data } = await this.$http.post("/financeiro/create-plano-principal", newNode);
          if (data.data.id) {
            newNode.id = data.data.id;
            this.$toast.success("Plano adicionado com sucesso!");
            this.treeData.push(newNode);
          }
        }
      } finally {
        this.removeLoadingToButton("saveNewNode");
        this.modalVisible = false;
      }
    },
    addChild(node) {
      this.newParentType = node.tipo;
      this.showAddModal(node);
    },
    deleteNode(node) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o plano de contas: " + node.descricao + "?",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/financeiro/delete-plano", node);
              this.handleDeleteNode(node);
              this.$toast.success("Plano de contas excluído!");
            }
          });
      });
    },
    handleDeleteNode(deletedNode) {
      const removeNode = (nodes, nodeToRemove) => {
        return nodes.filter((node) => {
          if (node.id === nodeToRemove.id) return false;
          if (node.children) node.children = removeNode(node.children, nodeToRemove);
          return true;
        });
      };
      this.treeData = removeNode(this.treeData, deletedNode);
    },
  },
};
</script>

<style scoped>
.plan-tabs {
  display: flex;
  border-bottom: 2px solid #dee2e6;
}
.plan-tab {
  background: none;
  border: none;
  padding: 8px 22px;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s;
}
.plan-tab:hover {
  color: #343a40;
}
.plan-tab.saidas:hover,
.plan-tab.saidas.active {
  color: #dc3545;
}
.plan-tab.saidas.active {
  border-bottom-color: #dc3545;
  font-weight: 600;
}
.plan-tab.entradas:hover,
.plan-tab.entradas.active {
  color: #28a745;
}
.plan-tab.entradas.active {
  border-bottom-color: #28a745;
  font-weight: 600;
}
.plan-table {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 12px;
}
.plan-table-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  background: #f8f9fa;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #dee2e6;
  color: #495057;
}
.plan-empty {
  padding: 24px 16px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}
</style>